import { api } from './baseAPI.mjs';

"use strict";
const addTagTypes = ["API Discovery", "LogsDrilldownDefaultColumns", "LogsDrilldownDefaultLabels"];
const injectedRtkApi = api.enhanceEndpoints({
  addTagTypes
}).injectEndpoints({
  endpoints: (build) => ({
    getApiResources: build.query({
      query: () => ({ url: `/` }),
      providesTags: ["API Discovery"]
    }),
    listLogsDrilldownDefaultColumns: build.query({
      query: (queryArg) => ({
        url: `/logsdrilldowndefaultcolumns`,
        params: {
          pretty: queryArg.pretty,
          allowWatchBookmarks: queryArg.allowWatchBookmarks,
          continue: queryArg["continue"],
          fieldSelector: queryArg.fieldSelector,
          labelSelector: queryArg.labelSelector,
          limit: queryArg.limit,
          resourceVersion: queryArg.resourceVersion,
          resourceVersionMatch: queryArg.resourceVersionMatch,
          sendInitialEvents: queryArg.sendInitialEvents,
          timeoutSeconds: queryArg.timeoutSeconds,
          watch: queryArg.watch
        }
      }),
      providesTags: ["LogsDrilldownDefaultColumns"]
    }),
    createLogsDrilldownDefaultColumns: build.mutation({
      query: (queryArg) => ({
        url: `/logsdrilldowndefaultcolumns`,
        method: "POST",
        body: queryArg.logsDrilldownDefaultColumns,
        params: {
          pretty: queryArg.pretty,
          dryRun: queryArg.dryRun,
          fieldManager: queryArg.fieldManager,
          fieldValidation: queryArg.fieldValidation
        }
      }),
      invalidatesTags: ["LogsDrilldownDefaultColumns"]
    }),
    deletecollectionLogsDrilldownDefaultColumns: build.mutation({
      query: (queryArg) => ({
        url: `/logsdrilldowndefaultcolumns`,
        method: "DELETE",
        params: {
          pretty: queryArg.pretty,
          continue: queryArg["continue"],
          dryRun: queryArg.dryRun,
          fieldSelector: queryArg.fieldSelector,
          gracePeriodSeconds: queryArg.gracePeriodSeconds,
          ignoreStoreReadErrorWithClusterBreakingPotential: queryArg.ignoreStoreReadErrorWithClusterBreakingPotential,
          labelSelector: queryArg.labelSelector,
          limit: queryArg.limit,
          orphanDependents: queryArg.orphanDependents,
          propagationPolicy: queryArg.propagationPolicy,
          resourceVersion: queryArg.resourceVersion,
          resourceVersionMatch: queryArg.resourceVersionMatch,
          sendInitialEvents: queryArg.sendInitialEvents,
          timeoutSeconds: queryArg.timeoutSeconds
        }
      }),
      invalidatesTags: ["LogsDrilldownDefaultColumns"]
    }),
    getLogsDrilldownDefaultColumns: build.query({
      query: (queryArg) => ({
        url: `/logsdrilldowndefaultcolumns/${queryArg.name}`,
        params: {
          pretty: queryArg.pretty
        }
      }),
      providesTags: ["LogsDrilldownDefaultColumns"]
    }),
    replaceLogsDrilldownDefaultColumns: build.mutation({
      query: (queryArg) => ({
        url: `/logsdrilldowndefaultcolumns/${queryArg.name}`,
        method: "PUT",
        body: queryArg.logsDrilldownDefaultColumns,
        params: {
          pretty: queryArg.pretty,
          dryRun: queryArg.dryRun,
          fieldManager: queryArg.fieldManager,
          fieldValidation: queryArg.fieldValidation
        }
      }),
      invalidatesTags: ["LogsDrilldownDefaultColumns"]
    }),
    deleteLogsDrilldownDefaultColumns: build.mutation({
      query: (queryArg) => ({
        url: `/logsdrilldowndefaultcolumns/${queryArg.name}`,
        method: "DELETE",
        params: {
          pretty: queryArg.pretty,
          dryRun: queryArg.dryRun,
          gracePeriodSeconds: queryArg.gracePeriodSeconds,
          ignoreStoreReadErrorWithClusterBreakingPotential: queryArg.ignoreStoreReadErrorWithClusterBreakingPotential,
          orphanDependents: queryArg.orphanDependents,
          propagationPolicy: queryArg.propagationPolicy
        }
      }),
      invalidatesTags: ["LogsDrilldownDefaultColumns"]
    }),
    updateLogsDrilldownDefaultColumns: build.mutation({
      query: (queryArg) => ({
        url: `/logsdrilldowndefaultcolumns/${queryArg.name}`,
        method: "PATCH",
        body: queryArg.patch,
        params: {
          pretty: queryArg.pretty,
          dryRun: queryArg.dryRun,
          fieldManager: queryArg.fieldManager,
          fieldValidation: queryArg.fieldValidation,
          force: queryArg.force
        }
      }),
      invalidatesTags: ["LogsDrilldownDefaultColumns"]
    }),
    getLogsDrilldownDefaultColumnsStatus: build.query({
      query: (queryArg) => ({
        url: `/logsdrilldowndefaultcolumns/${queryArg.name}/status`,
        params: {
          pretty: queryArg.pretty
        }
      }),
      providesTags: ["LogsDrilldownDefaultColumns"]
    }),
    replaceLogsDrilldownDefaultColumnsStatus: build.mutation({
      query: (queryArg) => ({
        url: `/logsdrilldowndefaultcolumns/${queryArg.name}/status`,
        method: "PUT",
        body: queryArg.logsDrilldownDefaultColumns,
        params: {
          pretty: queryArg.pretty,
          dryRun: queryArg.dryRun,
          fieldManager: queryArg.fieldManager,
          fieldValidation: queryArg.fieldValidation
        }
      }),
      invalidatesTags: ["LogsDrilldownDefaultColumns"]
    }),
    updateLogsDrilldownDefaultColumnsStatus: build.mutation({
      query: (queryArg) => ({
        url: `/logsdrilldowndefaultcolumns/${queryArg.name}/status`,
        method: "PATCH",
        body: queryArg.patch,
        params: {
          pretty: queryArg.pretty,
          dryRun: queryArg.dryRun,
          fieldManager: queryArg.fieldManager,
          fieldValidation: queryArg.fieldValidation,
          force: queryArg.force
        }
      }),
      invalidatesTags: ["LogsDrilldownDefaultColumns"]
    }),
    listLogsDrilldownDefaultLabels: build.query({
      query: (queryArg) => ({
        url: `/logsdrilldowndefaultlabels`,
        params: {
          pretty: queryArg.pretty,
          allowWatchBookmarks: queryArg.allowWatchBookmarks,
          continue: queryArg["continue"],
          fieldSelector: queryArg.fieldSelector,
          labelSelector: queryArg.labelSelector,
          limit: queryArg.limit,
          resourceVersion: queryArg.resourceVersion,
          resourceVersionMatch: queryArg.resourceVersionMatch,
          sendInitialEvents: queryArg.sendInitialEvents,
          timeoutSeconds: queryArg.timeoutSeconds,
          watch: queryArg.watch
        }
      }),
      providesTags: ["LogsDrilldownDefaultLabels"]
    }),
    createLogsDrilldownDefaultLabels: build.mutation({
      query: (queryArg) => ({
        url: `/logsdrilldowndefaultlabels`,
        method: "POST",
        body: queryArg.logsDrilldownDefaultLabels,
        params: {
          pretty: queryArg.pretty,
          dryRun: queryArg.dryRun,
          fieldManager: queryArg.fieldManager,
          fieldValidation: queryArg.fieldValidation
        }
      }),
      invalidatesTags: ["LogsDrilldownDefaultLabels"]
    }),
    deletecollectionLogsDrilldownDefaultLabels: build.mutation({
      query: (queryArg) => ({
        url: `/logsdrilldowndefaultlabels`,
        method: "DELETE",
        params: {
          pretty: queryArg.pretty,
          continue: queryArg["continue"],
          dryRun: queryArg.dryRun,
          fieldSelector: queryArg.fieldSelector,
          gracePeriodSeconds: queryArg.gracePeriodSeconds,
          ignoreStoreReadErrorWithClusterBreakingPotential: queryArg.ignoreStoreReadErrorWithClusterBreakingPotential,
          labelSelector: queryArg.labelSelector,
          limit: queryArg.limit,
          orphanDependents: queryArg.orphanDependents,
          propagationPolicy: queryArg.propagationPolicy,
          resourceVersion: queryArg.resourceVersion,
          resourceVersionMatch: queryArg.resourceVersionMatch,
          sendInitialEvents: queryArg.sendInitialEvents,
          timeoutSeconds: queryArg.timeoutSeconds
        }
      }),
      invalidatesTags: ["LogsDrilldownDefaultLabels"]
    }),
    getLogsDrilldownDefaultLabels: build.query({
      query: (queryArg) => ({
        url: `/logsdrilldowndefaultlabels/${queryArg.name}`,
        params: {
          pretty: queryArg.pretty
        }
      }),
      providesTags: ["LogsDrilldownDefaultLabels"]
    }),
    replaceLogsDrilldownDefaultLabels: build.mutation({
      query: (queryArg) => ({
        url: `/logsdrilldowndefaultlabels/${queryArg.name}`,
        method: "PUT",
        body: queryArg.logsDrilldownDefaultLabels,
        params: {
          pretty: queryArg.pretty,
          dryRun: queryArg.dryRun,
          fieldManager: queryArg.fieldManager,
          fieldValidation: queryArg.fieldValidation
        }
      }),
      invalidatesTags: ["LogsDrilldownDefaultLabels"]
    }),
    deleteLogsDrilldownDefaultLabels: build.mutation({
      query: (queryArg) => ({
        url: `/logsdrilldowndefaultlabels/${queryArg.name}`,
        method: "DELETE",
        params: {
          pretty: queryArg.pretty,
          dryRun: queryArg.dryRun,
          gracePeriodSeconds: queryArg.gracePeriodSeconds,
          ignoreStoreReadErrorWithClusterBreakingPotential: queryArg.ignoreStoreReadErrorWithClusterBreakingPotential,
          orphanDependents: queryArg.orphanDependents,
          propagationPolicy: queryArg.propagationPolicy
        }
      }),
      invalidatesTags: ["LogsDrilldownDefaultLabels"]
    }),
    updateLogsDrilldownDefaultLabels: build.mutation({
      query: (queryArg) => ({
        url: `/logsdrilldowndefaultlabels/${queryArg.name}`,
        method: "PATCH",
        body: queryArg.patch,
        params: {
          pretty: queryArg.pretty,
          dryRun: queryArg.dryRun,
          fieldManager: queryArg.fieldManager,
          fieldValidation: queryArg.fieldValidation,
          force: queryArg.force
        }
      }),
      invalidatesTags: ["LogsDrilldownDefaultLabels"]
    }),
    getLogsDrilldownDefaultLabelsStatus: build.query({
      query: (queryArg) => ({
        url: `/logsdrilldowndefaultlabels/${queryArg.name}/status`,
        params: {
          pretty: queryArg.pretty
        }
      }),
      providesTags: ["LogsDrilldownDefaultLabels"]
    }),
    replaceLogsDrilldownDefaultLabelsStatus: build.mutation({
      query: (queryArg) => ({
        url: `/logsdrilldowndefaultlabels/${queryArg.name}/status`,
        method: "PUT",
        body: queryArg.logsDrilldownDefaultLabels,
        params: {
          pretty: queryArg.pretty,
          dryRun: queryArg.dryRun,
          fieldManager: queryArg.fieldManager,
          fieldValidation: queryArg.fieldValidation
        }
      }),
      invalidatesTags: ["LogsDrilldownDefaultLabels"]
    }),
    updateLogsDrilldownDefaultLabelsStatus: build.mutation({
      query: (queryArg) => ({
        url: `/logsdrilldowndefaultlabels/${queryArg.name}/status`,
        method: "PATCH",
        body: queryArg.patch,
        params: {
          pretty: queryArg.pretty,
          dryRun: queryArg.dryRun,
          fieldManager: queryArg.fieldManager,
          fieldValidation: queryArg.fieldValidation,
          force: queryArg.force
        }
      }),
      invalidatesTags: ["LogsDrilldownDefaultLabels"]
    })
  }),
  overrideExisting: false
});
const {
  useGetApiResourcesQuery,
  useLazyGetApiResourcesQuery,
  useListLogsDrilldownDefaultColumnsQuery,
  useLazyListLogsDrilldownDefaultColumnsQuery,
  useCreateLogsDrilldownDefaultColumnsMutation,
  useDeletecollectionLogsDrilldownDefaultColumnsMutation,
  useGetLogsDrilldownDefaultColumnsQuery,
  useLazyGetLogsDrilldownDefaultColumnsQuery,
  useReplaceLogsDrilldownDefaultColumnsMutation,
  useDeleteLogsDrilldownDefaultColumnsMutation,
  useUpdateLogsDrilldownDefaultColumnsMutation,
  useGetLogsDrilldownDefaultColumnsStatusQuery,
  useLazyGetLogsDrilldownDefaultColumnsStatusQuery,
  useReplaceLogsDrilldownDefaultColumnsStatusMutation,
  useUpdateLogsDrilldownDefaultColumnsStatusMutation,
  useListLogsDrilldownDefaultLabelsQuery,
  useLazyListLogsDrilldownDefaultLabelsQuery,
  useCreateLogsDrilldownDefaultLabelsMutation,
  useDeletecollectionLogsDrilldownDefaultLabelsMutation,
  useGetLogsDrilldownDefaultLabelsQuery,
  useLazyGetLogsDrilldownDefaultLabelsQuery,
  useReplaceLogsDrilldownDefaultLabelsMutation,
  useDeleteLogsDrilldownDefaultLabelsMutation,
  useUpdateLogsDrilldownDefaultLabelsMutation,
  useGetLogsDrilldownDefaultLabelsStatusQuery,
  useLazyGetLogsDrilldownDefaultLabelsStatusQuery,
  useReplaceLogsDrilldownDefaultLabelsStatusMutation,
  useUpdateLogsDrilldownDefaultLabelsStatusMutation
} = injectedRtkApi;

export { addTagTypes, injectedRtkApi as generatedAPI, useCreateLogsDrilldownDefaultColumnsMutation, useCreateLogsDrilldownDefaultLabelsMutation, useDeleteLogsDrilldownDefaultColumnsMutation, useDeleteLogsDrilldownDefaultLabelsMutation, useDeletecollectionLogsDrilldownDefaultColumnsMutation, useDeletecollectionLogsDrilldownDefaultLabelsMutation, useGetApiResourcesQuery, useGetLogsDrilldownDefaultColumnsQuery, useGetLogsDrilldownDefaultColumnsStatusQuery, useGetLogsDrilldownDefaultLabelsQuery, useGetLogsDrilldownDefaultLabelsStatusQuery, useLazyGetApiResourcesQuery, useLazyGetLogsDrilldownDefaultColumnsQuery, useLazyGetLogsDrilldownDefaultColumnsStatusQuery, useLazyGetLogsDrilldownDefaultLabelsQuery, useLazyGetLogsDrilldownDefaultLabelsStatusQuery, useLazyListLogsDrilldownDefaultColumnsQuery, useLazyListLogsDrilldownDefaultLabelsQuery, useListLogsDrilldownDefaultColumnsQuery, useListLogsDrilldownDefaultLabelsQuery, useReplaceLogsDrilldownDefaultColumnsMutation, useReplaceLogsDrilldownDefaultColumnsStatusMutation, useReplaceLogsDrilldownDefaultLabelsMutation, useReplaceLogsDrilldownDefaultLabelsStatusMutation, useUpdateLogsDrilldownDefaultColumnsMutation, useUpdateLogsDrilldownDefaultColumnsStatusMutation, useUpdateLogsDrilldownDefaultLabelsMutation, useUpdateLogsDrilldownDefaultLabelsStatusMutation };
//# sourceMappingURL=endpoints.gen.mjs.map
